import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Components/Header/Header";
import styles from "../../Style";
import EventTypeModel from "./EventUpdateComponents/EventTypeModel";
import ArtTypeModel from "./EventUpdateComponents/ArtTypeModel";
import AddArtists from "./EventUpdateComponents/AddArtists";
import "react-datepicker/dist/react-datepicker.css";
import GoogleLocation from "./EventUpdateComponents/GoogleLocation";
import DateTimePicker from "./EventUpdateComponents/DateTimePicker";
import AllowArtistsSignUp from "./EventUpdateComponents/AllowArtistsSignUp";
import AutoRepeat from "./EventUpdateComponents/AutoRepeat";
import EventVisibility from "./EventUpdateComponents/EventVisibility";
import EventEntry from "./EventUpdateComponents/EventEntry";
import EventTicketStub from "./EventUpdateComponents/EventTicketStub";
import { validateForm } from "./EventUpdateComponents/validateForm";
import {
  apiCallGetEventDetails,
  apiCallPostArtCancel,
} from "../../../Core/Apicall";
import { EventUpdataDetails } from "./EventUpdateComponents/EventUpdateDetails";
import { onApiCallUpdata } from "./EventUpdateComponents/onApiCallUpdata";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormContext } from "./FormProvider";
import moment from "moment";
import dayjs from "dayjs";
import CustomConfirmModal from "../../../Components/CustomConfirmModal/CustomConfirmModal";
const CustomEventUpdate = () => {
  const [EventDetails, setEventDetails] = useState();
  const { formData, setFormData, errors, setErrors } = useFormContext();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isProfileData = useSelector((state) => state.isProfileData);
  const onApiCallUserDetails = async () => {
    const param = {
      eventId: location.state.eventId,
    };
    try {
      const response = await apiCallGetEventDetails(param);
      setEventDetails(response.data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  useEffect(() => {
    if (location?.state?.eventId) {
      if (EventDetails != undefined) {
        EventUpdataDetails(EventDetails, setFormData, formData);
      }
    }
  }, [EventDetails]);

  useEffect(() => {
    if (
      formData.ArtRunner === "Open Mic" ||
      formData.ArtRunner === "Workshop"
    ) {
      setFormData((prevForm) => ({
        ...prevForm,
        PersonallyApprove: true,
      }));
    } else {
      setFormData((prevForm) => ({
        ...prevForm,
        PersonallyApprove:
          EventDetails?.artistSignupVisibility?.allowArtistSignUp || false,
      }));
    }
  }, [formData.ArtRunner]);

  useEffect(() => {
    if (location.state.eventId) {
      onApiCallUserDetails();
    }
  }, [location]);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm(formData, setErrors)) {
      onApiCallUpdata(
        formData,
        location,
        EventDetails,
        isProfileData,
        navigate,
        dispatch,
      );
    }
  };

  const handleOnCancel = async () => {
    try {
      const data = {
        eventId: EventDetails?.eventId,
        userId: EventDetails?.userId,
        cancelFeatureEvent: false,
        isRefund: false,
      };
      const res = await apiCallPostArtCancel(data);
      navigate(-1);
      toast.success(res?.message || "Session cancelled successfully.");
    } catch (error) {
      toast.error(error || "Failed to cancel the session.");
      console.log(error);
    }
  };
  return (
    <div>
      <Header
        name={
          location?.state?.AdminEvent
            ? "Admin Event Add"
            : location?.state?.adminEventEdit
              ? "Admin Event Edit"
              : "Event Edit"
        }
      />
      <div className="EventUpdate" style={styles.EventUpdate}>
        <button className="close_icon" onClick={() => navigate(-1)}>
          X
        </button>
        <div className="modal-content bg-Blue grid p-4 relative">
          <h2>
            {location?.state?.AdminEvent
              ? "Admin Event Add"
              : location?.state?.adminEventEdit
                ? "Admin Event Edit"
                : "Event Edit"}
          </h2>
          <form className="p-4 bg-white rounded shadow-md">
            <EventTypeModel />
            <ArtTypeModel />
            <div
              className={`Category_name ${errors.ShowName ? "invalid" : "valid"
                } `}
              style={{ marginBottom: "20px", height: "50px" }}
            >
              <input
                className="Event_input"
                type="text"
                value={formData.ShowName}
                onChange={(e) =>
                  setFormData((prevForm) => ({
                    ...prevForm,
                    ShowName: e.target.value,
                  }))
                }
                placeholder="Show Name"
              />
            </div>

            {/* <div
              className={`Category_name ${
                errors.ShowDetails ? "invalid" : "valid"
              } `}
              style={{ marginBottom: "20px", height: "50px" }}
            >
              <input
                className="Event_input"
                type="text"
                value={formData.ShowDetails}
                onChange={(e) =>
                  setFormData((prevForm) => ({
                    ...prevForm,
                    ShowDetails: e.target.value,
                  }))
                }
                placeholder="Show Details"
              />
            </div> */}
            <div
              className={`Category_name ${errors.ShowDetails ? "invalid" : "valid EventUpdateZindex"
                }`}
              style={{
                width: "100%",
                padding: 5,
                boxSizing: "border-box",
                marginBottom: "20px",
                height: 140,
              }}
            >
              <textarea
                value={formData.ShowDetails || ""}
                onChange={(e) =>
                  setFormData((prevForm) => ({
                    ...prevForm,
                    ShowDetails: e.target.value,
                  }))
                }
                placeholder="Show Details"
                style={{
                  maxWidth: "100%",
                  minWidth: "100%",
                  maxHeight: "100%",
                  minHeight: "100%",
                  backgroundColor: "transparent",
                }}
              ></textarea>
            </div>

            <DateTimePicker />
            <div style={{ fontSize: "12px", marginBottom: "10px" }}>
              Venue Details
            </div>
            <div className="venue-input" style={styles.EventDate}>
              <div
                className={`Category_name ${errors.VenueName ? "invalid" : "valid"
                  }`}
                style={{ marginBottom: "10px", width: "100%" }}
              >
                <input
                  type="text"
                  placeholder="Venue Name"
                  className="fontSize16"
                  value={formData.VenueName}
                  onChange={(e) =>
                    setFormData((prevForm) => ({
                      ...prevForm,
                      VenueName: e.target.value,
                    }))
                  }
                />
              </div>
              <GoogleLocation />
            </div>
            <AddArtists />
            {formData.ArtRunner === "Tour" ? (
              ""
            ) : (
              <>
                <AllowArtistsSignUp />
                <AutoRepeat
                  EventDetails={EventDetails}
                  name={
                    location?.state?.AdminEvent
                      ? "Admin Event Add"
                      : location?.state?.adminEventEdit
                        ? "Admin Event Edit"
                        : "Event Edit"
                  }
                />
              </>
            )}
            <EventVisibility />
            <EventEntry />
            <EventTicketStub />
            <div
              style={{
                display: "flex",
                gap: "40px",
                maxWidth: "500px",
                margin: "auto",
              }}
            >
              <div onClick={() => {
                if (EventDetails?.isCancel) {
                  toast.info("This event has been cancelled and cannot be edited.")
                } else {
                  setShowCancelModal(true)
                }
              }
              }

                style={styles.eventCancel}>
                Cancel
              </div>
              <div onClick={(e) => handleSubmit(e)} style={styles.eventSubmit}>
                Submit
              </div>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />


      <CustomConfirmModal
        visible={showCancelModal}
        title="Cancel Event"
        message="Are you sure you want to cancel this event? This action cannot be undone."
        confirmText="Yes, Cancel"
        cancelText="Keep Event"
        onCancel={() => setShowCancelModal(false)}
        onConfirm={handleOnCancel}
      />
    </div>
  );
};

export default CustomEventUpdate;
